<div *nzModalTitle class="px-0 py-1 w-full">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">{{data?.nzTitle}}</p>
    </div>
</div>
<div #modalContent class="w-full h-full p-5 m-0">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        <form [formGroup]="form" nz-form [nzLayout]="'vertical'">
            <nz-form-item nzFor="packagingTypeSelected">
                <nz-form-label nzRequired>Seleccione un tipo de formato:</nz-form-label>
                <nz-form-control nzErrorTip="Seleccione un tipo de formato">
                    <nz-select nzShowSearch class="w-full" formControlName="packagingTypeSelected">
                        @for(packagingType of packagingTypes; track packagingType){
                            <nz-option [nzValue]="packagingType" [nzLabel]="packagingType.name + ' - Cant. por formato: ' + packagingType.quantityPerPackaging + '' + packagingType.measurementUnit?.abbreviation"/>
                        }
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

        </form>
    }
</div>
<div *nzModalFooter class="px-0 py-1 w-full">
    <div class="flex justify-end">
        <button (click)="handleCancel()" class="button secondary-button mr-2">
            Cancelar
        </button>

        <button nz-button class="button primary-button" (click)="handleSave()" [nzLoading]="isSaving">
            Aceptar
        </button>
    </div>
</div>
